import { useEffect, useState } from 'react'
import { toast } from 'sonner'
import { BellRing, Send, Check } from 'lucide-react'
import { notificationService, NotificationDelivery, TargetType, Priority } from '@/services/notificationService'

export default function NotificationsPage() {
    const [deliveries, setDeliveries] = useState<NotificationDelivery[]>([])
    const [form, setForm] = useState({ title: '', body: '', targetType: 'ROLES' as TargetType, targetSpec: 'SUPERVISOR,COORDINADOR,ADMINISTRADOR', priority: 'HIGH' as Priority })

    const load = () => { notificationService.myDeliveries().then(setDeliveries).catch(() => {}) }
    useEffect(load, [])

    const send = async (e: React.FormEvent) => {
        e.preventDefault()
        if (!form.title.trim()) return toast.error('Indica un título')
        try { await notificationService.send(form); toast.success('Campaña enviada'); load() }
        catch { toast.error('Error al enviar (¿rol de mando?)') }
    }

    const ack = async (id: number) => { try { await notificationService.ack(id); load() } catch { /* noop */ } }

    const inp = 'w-full bg-gray-900 border border-gray-700 rounded px-3 py-2 text-sm'
    const card = 'bg-gray-800/40 border border-gray-700 rounded-lg p-4'

    return (
        <div className="p-6 text-gray-100">
            <div className="flex items-center gap-3 mb-6"><BellRing className="text-indigo-400" /><h1 className="text-2xl font-bold">Notificaciones</h1></div>

            <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
                {/* Enviar campaña (mando) */}
                <form onSubmit={send} className={card + ' space-y-3'}>
                    <h2 className="font-semibold flex items-center gap-2"><Send size={16} /> Enviar notificación</h2>
                    <input className={inp} placeholder="Título" value={form.title} onChange={(e) => setForm({ ...form, title: e.target.value })} />
                    <textarea className={inp} rows={2} placeholder="Mensaje" value={form.body} onChange={(e) => setForm({ ...form, body: e.target.value })} />
                    <select className={inp} value={form.targetType} onChange={(e) => setForm({ ...form, targetType: e.target.value as TargetType })}>
                        {['ALL', 'ROLES', 'TEAM', 'USERS', 'GEOFENCE'].map((t) => <option key={t} value={t}>{t}</option>)}
                    </select>
                    <input className={inp} placeholder="Destino (roles/usuarios/equipo/idGeocerca)" value={form.targetSpec} onChange={(e) => setForm({ ...form, targetSpec: e.target.value })} />
                    <select className={inp} value={form.priority} onChange={(e) => setForm({ ...form, priority: e.target.value as Priority })}>
                        {['NORMAL', 'HIGH', 'CRITICAL'].map((p) => <option key={p} value={p}>{p}</option>)}
                    </select>
                    <button className="w-full bg-indigo-600 hover:bg-indigo-500 rounded px-3 py-2 text-sm font-medium">Enviar</button>
                </form>

                {/* Mis notificaciones */}
                <div className={card}>
                    <h2 className="font-semibold mb-3">Mis notificaciones</h2>
                    <div className="space-y-2 max-h-96 overflow-y-auto">
                        {deliveries.map((d) => (
                            <div key={d.id} className="bg-gray-900/50 rounded px-3 py-2 text-sm flex items-center justify-between">
                                <span>Campaña #{d.campaignId} · <span className="text-gray-400">{d.status}</span></span>
                                {d.status !== 'ACK' && (
                                    <button onClick={() => ack(d.id)} className="text-emerald-400 hover:text-emerald-300 flex items-center gap-1 text-xs"><Check size={14} /> Acusar</button>
                                )}
                            </div>
                        ))}
                        {deliveries.length === 0 && <p className="text-gray-500 text-sm">Sin notificaciones.</p>}
                    </div>
                </div>
            </div>
        </div>
    )
}
